import { render, staticRenderFns } from "./PlateStockPopular.vue?vue&type=template&id=596eb07e"
import script from "./PlateStockPopular.vue?vue&type=script&lang=js"
export * from "./PlateStockPopular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports